'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var exporter = require('ipfs-unixfs-exporter');

var applyDefaultOptions = require('./utils/apply-default-options');

var toMfsPath = require('./utils/to-mfs-path');

var _require = require('../../utils'),
    MFS_FILE_TYPES = _require.MFS_FILE_TYPES;

var defaultOptions = {};

var toOutput = function toOutput(fsEntry) {
  var type = 0;
  var size = fsEntry.node.size || fsEntry.node.length;
  var mode;
  var mtime;

  if (fsEntry.unixfs) {
    size = fsEntry.unixfs.fileSize();
    type = MFS_FILE_TYPES[fsEntry.unixfs.type];
    mode = fsEntry.unixfs.mode;
    mtime = fsEntry.unixfs.mtime;
  }

  var output = {
    cid: fsEntry.cid,
    name: fsEntry.name,
    type: type,
    size: size
  };

  if (mtime !== undefined) {
    output.mtime = mtime;
  }

  if (mode !== undefined) {
    output.mode = mode;
  }

  return output;
};

module.exports = function (context) {
  return /*#__PURE__*/function () {
    var _mfsLs = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var path,
          options,
          mfsPath,
          fsDir,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          fsEntry,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              path = _args.length > 0 && _args[0] !== undefined ? _args[0] : '/';
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              if (typeof path === 'object' && !(path instanceof String)) {
                options = path;
                path = '/';
              }

              options = applyDefaultOptions(options, defaultOptions);
              _context.next = 6;
              return _awaitAsyncGenerator(toMfsPath(context, path));

            case 6:
              mfsPath = _context.sent;
              _context.next = 9;
              return _awaitAsyncGenerator(exporter(mfsPath.mfsPath, context.ipld));

            case 9:
              fsDir = _context.sent;

              if (!(!fsDir.unixfs || !fsDir.unixfs.type.includes('directory'))) {
                _context.next = 14;
                break;
              }

              _context.next = 13;
              return toOutput(fsDir);

            case 13:
              return _context.abrupt("return");

            case 14:
              // directory, perhaps sharded
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 16;
              _iterator = _asyncIterator(fsDir.content(options));

            case 18:
              _context.next = 20;
              return _awaitAsyncGenerator(_iterator.next());

            case 20:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 24;
              return _awaitAsyncGenerator(_step.value);

            case 24:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 32;
                break;
              }

              fsEntry = _value;
              _context.next = 29;
              return toOutput(fsEntry);

            case 29:
              _iteratorNormalCompletion = true;
              _context.next = 18;
              break;

            case 32:
              _context.next = 38;
              break;

            case 34:
              _context.prev = 34;
              _context.t0 = _context["catch"](16);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 38:
              _context.prev = 38;
              _context.prev = 39;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 43;
                break;
              }

              _context.next = 43;
              return _awaitAsyncGenerator(_iterator.return());

            case 43:
              _context.prev = 43;

              if (!_didIteratorError) {
                _context.next = 46;
                break;
              }

              throw _iteratorError;

            case 46:
              return _context.finish(43);

            case 47:
              return _context.finish(38);

            case 48:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[16, 34, 38, 48], [39,, 43, 47]]);
    }));

    function mfsLs() {
      return _mfsLs.apply(this, arguments);
    }

    return mfsLs;
  }();
};